import FormAutoComplete from "@bvhi/ui-base/src/AutoComplete";
import { useTranslation } from "react-i18next";

interface Props {
  name: string;
  options: string[];
}

export const PlatformCatalogAccessMatchingRuleColumnSelectField = ({ options, name }: Props) => {
  const { t } = useTranslation(["catalogs"]);

  return (
    <FormAutoComplete
      freeSolo
      fullWidth
      label={t("catalogs:catalogs.form.fields.column.label")}
      name={name}
      options={options}
      placeholder={t("catalogs:catalogs.form.fields.column.placeholder")}
    />
  );
};
